import DiscoveryPage from './DiscoveryPage'

export default DiscoveryPage
